<div class="wizard-shell" data-testid="lead-wizard">
  @if (loading()) {
    <div class="loading-container flex flex-column flex-align-center p-lg">
      <app-spinner />
    </div>
  } @else if (savedFinal()) {
    <div class="saved-screen flex flex-column flex-align-center gap-sm" data-testid="wizard-saved-state">
      <div class="saved-check">
        <app-icon name="check" [size]="26" />
      </div>
      <div class="saved-title">{{ 'interactions.wizard.saved.title' | translate }}</div>
    </div>
  } @else if (pendingDncConfirm()) {
    <!-- confirm dialog renders as a sibling below -->
  } @else {
    <div class="wizard-top-bar">
      <div class="step-of" data-testid="wizard-step-of">
        {{ 'interactions.wizard.stepOf' | translate: { step: (currentStep() + 1).toString(), total: '5' } }}
      </div>
      <button type="button" class="icon-button" (click)="onCancel()" data-testid="wizard-close-button">
        <app-icon name="x" [size]="16" />
      </button>
    </div>

    @if (error()) {
      <div class="error-container p-md" data-testid="wizard-error">
        <p>{{ error() }}</p>
      </div>
    }

    <div class="wizard-body">
      <app-lead-wizard-step-indicator [steps]="stepLabels()" [currentStep]="currentStep()" (stepSelected)="goToStep($event)" />

      <div class="wizard-content" [attr.data-testid]="'wizard-step-' + currentStep()">
        @switch (currentStep()) {
          @case (0) {
            <div class="step-heading">
              <div class="step-title">{{ stepLabels()[0] }}</div>
              <div class="step-subtitle">{{ 'interactions.wizard.contact.subtitle' | translate }}</div>
            </div>
            <form [formGroup]="contactForm">
              <formly-form [form]="contactForm" [fields]="contactFields" [model]="contactModel" />
            </form>
            @if (showContactMethodError()) {
              <div class="field-error" data-testid="wizard-contact-method-error">
                {{ 'interactions.wizard.contact.methodRequiredError' | translate }}
              </div>
            }
          }
          @case (1) {
            <div class="step-heading">
              <div class="step-title">{{ stepLabels()[1] }}</div>
              <div class="step-subtitle">{{ 'interactions.wizard.interested.subtitle' | translate }}</div>
            </div>
            <form [formGroup]="interestedForm">
              <formly-form [form]="interestedForm" [fields]="interestedFields" [model]="interestedModel" />
            </form>
            @if (grandTotal() > 0) {
              <div class="grand-total" data-testid="wizard-grand-total">
                {{ 'interactions.form.lead.grandTotal' | translate }}: {{ grandTotal() | number: '1.2-2' }} {{ interestedModel.currency }}
              </div>
            }
          }
          @case (2) {
            <div class="step-heading">
              <div class="step-title">{{ stepLabels()[2] }}</div>
              <div class="step-subtitle">{{ 'interactions.wizard.details.subtitle' | translate }}</div>
            </div>
            <form [formGroup]="detailsForm">
              <formly-form [form]="detailsForm" [fields]="detailsFields" [model]="detailsModel" />
            </form>
          }
          @case (3) {
            <div class="step-heading">
              <div class="step-title">{{ stepLabels()[3] }}</div>
              <div class="step-subtitle">{{ 'interactions.wizard.schedule.subtitle' | translate }}</div>
            </div>
            <form [formGroup]="scheduleForm">
              <formly-form [form]="scheduleForm" [fields]="scheduleFields" [model]="scheduleModel" />
            </form>
          }
          @case (4) {
            <div class="step-heading">
              <div class="step-title">{{ stepLabels()[4] }}</div>
            </div>
            <div class="review-grid">
              <div class="review-card">
                <div class="review-card-header">
                  <span class="review-card-title">{{ stepLabels()[0] }}</span>
                  <button type="button" class="review-edit" (click)="goToStep(0)" data-testid="wizard-review-edit-0">
                    {{ 'interactions.wizard.review.editLink' | translate }}
                  </button>
                </div>
                <div class="review-card-body">
                  <div>{{ contactModel.contact_name }}</div>
                  <div>{{ contactModel.contact_phone }}</div>
                  <div>{{ contactModel.contact_email }}</div>
                </div>
              </div>

              <div class="review-card">
                <div class="review-card-header">
                  <span class="review-card-title">{{ stepLabels()[1] }}</span>
                  <button type="button" class="review-edit" (click)="goToStep(1)" data-testid="wizard-review-edit-1">
                    {{ 'interactions.wizard.review.editLink' | translate }}
                  </button>
                </div>
                <div class="review-card-body">
                  @for (item of interestedSummary(); track item.label) {
                    <div>{{ item.label }} ×{{ item.quantity }}</div>
                  }
                </div>
              </div>

              <div class="review-card">
                <div class="review-card-header">
                  <span class="review-card-title">{{ stepLabels()[2] }}</span>
                  <button type="button" class="review-edit" (click)="goToStep(2)" data-testid="wizard-review-edit-2">
                    {{ 'interactions.wizard.review.editLink' | translate }}
                  </button>
                </div>
                <div class="review-card-body">
                  @if (detailsModel.notes) {
                    <div>{{ detailsModel.notes }}</div>
                  }
                  @if (detailsModel.photos.length) {
                    <div class="review-photos">
                      @for (url of detailsModel.photos; track url) {
                        <img [src]="url" class="review-thumb" alt="" />
                      }
                    </div>
                  }
                </div>
              </div>

              <div class="review-card">
                <div class="review-card-header">
                  <span class="review-card-title">{{ stepLabels()[3] }}</span>
                  <button type="button" class="review-edit" (click)="goToStep(3)" data-testid="wizard-review-edit-3">
                    {{ 'interactions.wizard.review.editLink' | translate }}
                  </button>
                </div>
                <div class="review-card-body">{{ scheduleSummary() }}</div>
              </div>
            </div>
          }
        }
      </div>
    </div>

    <div class="wizard-bottom-bar">
      @if (currentStep() < 3) {
        @if (currentStep() > 0) {
          <app-button variant="outlined" (click)="back()" data-testid="wizard-back-button">
            {{ 'interactions.wizard.back' | translate }}
          </app-button>
        }
        <app-button variant="filled" class="ml-auto" (click)="next()" data-testid="wizard-next-button">
          {{ 'interactions.wizard.next' | translate }}
        </app-button>
      } @else if (currentStep() === 3) {
        <app-button variant="outlined" (click)="back()" data-testid="wizard-back-button">
          {{ 'interactions.wizard.back' | translate }}
        </app-button>
        <button type="button" class="skip-link" (click)="skipSchedule()" data-testid="wizard-skip-schedule">
          {{ 'interactions.wizard.skipSchedule' | translate }}
        </button>
        <app-button variant="filled" (click)="next()" data-testid="wizard-next-button">
          {{ 'interactions.wizard.next' | translate }}
        </app-button>
      } @else {
        <app-button variant="outlined" (click)="back()" data-testid="wizard-back-button">
          {{ 'interactions.wizard.back' | translate }}
        </app-button>
        <app-button variant="filled" [disabled]="saving()" (click)="save()" data-testid="wizard-save-button">
          {{ 'interactions.wizard.save' | translate }}
        </app-button>
      }
    </div>
  }
</div>

@if (pendingDncConfirm()) {
  <app-dnc-confirm-dialog [address]="address()" (confirmed)="confirmDncGate()" (cancelled)="cancelDncGate()" />
}
